import React, { useEffect, useRef } from 'react';

function ParagraphWithAnalytics({ paragraph, dataQaid, handleDataLinkClick }) {
    const paragraphElm = useRef(null);

    useEffect(() => {
        const aTags = paragraphElm.current.querySelectorAll('a');

        if (aTags.length > 0) {
            Array.from(aTags, (aTag) => aTag.addEventListener('click', handleDataLinkClick));

            return () => Array.from(aTags, (aTag) => aTag.removeEventListener('click', handleDataLinkClick));
        }

        return false;
    }, [handleDataLinkClick]);

    return (
        <span
            data-qaid={dataQaid}
            ref={paragraphElm}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: paragraph }}
        />
    );
}

export default ParagraphWithAnalytics;
